import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./auth/AuthProvider";
import { SiteSettingsProvider } from "./settings/SiteSettingsContext";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <SiteSettingsProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </SiteSettingsProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
